import { AnchorButton, Icon, IconSize, Position } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { Popover2 } from '@blueprintjs/popover2';
import classNames from 'classnames';
import * as React from 'react';
import { Tooltip } from 'vet-bones/components';
import { queryBuilderColors } from 'vet-bones/styles/colors';

import {
  TEST_IDS,
  getColorPickerSwatchButtonTestId,
} from 'src/constants/testIds';
import * as copy from 'src/templates/copy';
import { queryBuilderColorsById } from 'src/templates/styles/colors';

type ColorPickerSwatchProps = {
  color?: string;
};

const ColorPickerSwatch: React.VFC<ColorPickerSwatchProps> = ({ color }) => {
  return (
    <Icon
      className="sd-color-picker-swatch"
      color={color}
      icon={color ? IconNames.FullCircle : IconNames.Circle}
      size={IconSize.LARGE}
    />
  );
};

export type ColorPickerProps = {
  colorId: string;
  highlighted?: boolean;
  onSetColorId: (colorId: string) => void;
};

export const ColorPicker: React.VFC<ColorPickerProps> = ({
  colorId,
  highlighted,
  onSetColorId,
}) => {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <Popover2
      content={
        <div className="sd-color-picker-menu">
          <div className="sd-color-picker-swatches">
            {queryBuilderColors.map(({ id, color }) => (
              <AnchorButton
                key={id}
                active={colorId === id}
                data-testid={getColorPickerSwatchButtonTestId(id)}
                icon={<ColorPickerSwatch color={color} />}
                minimal
                onClick={() => {
                  onSetColorId(id);
                  setIsOpen(false);
                }}
              />
            ))}
          </div>
        </div>
      }
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      position={Position.BOTTOM_LEFT}
    >
      <Tooltip
        content={copy.components.colorPicker.tooltip}
        disabled={isOpen}
        position={Position.BOTTOM_LEFT}
      >
        <AnchorButton
          className={classNames(
            'sd-color-picker',
            'sd-draft-highlight-candidate',
            { 'sd-draft-highlight-candidate--highlighted': highlighted }
          )}
          data-testid={TEST_IDS.colorPicker.menuButton}
          icon={<ColorPickerSwatch color={queryBuilderColorsById[colorId]} />}
          minimal
          onClick={() => setIsOpen(true)}
        />
      </Tooltip>
    </Popover2>
  );
};
